import { SxProps, Theme } from "@mui/material/styles";

export const sectionTitleStyle: SxProps<Theme> = (theme) => ({
    color: theme.palette.primary.main,
    textTransform: "uppercase",
    fontWeight: "bold",
    fontSize: "2rem",
    marginBottom: theme.spacing(3),
    fontFamily: "HsvSlab", // Example custom font
});
